import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { QuestionsResponse, SubmitKYCAnswersInputDto, Question, UploadKycInputDto, GetRegisterationQuestionsOutputDto } from "../data-models/kyc.data.models";
import { EInvestorType, GeneralResponse } from 'src/app/shared/shared-data-models';



@Injectable({ providedIn: 'root' })
export class KycDataService {
  private controllerUrl: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/portal/KYC/`;

  constructor(
    private baseApi: BaseApiService<any>,
  ) { }

  GetRegistrationQuestions(investorUserId: string,investTypeId:EInvestorType): Observable<GeneralResponse<GetRegisterationQuestionsOutputDto[]>> {
    return this.baseApi.Get(`${this.controllerUrl}GetRegistrationQuestions?investorUserId=${investorUserId}&investTypeId=${investTypeId} `);
  }
  AcceptAcknowledgment(investorUserId:string,isAcceptAcknowledgment: boolean): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}AcceptAcknowledgment?investorUserId=${investorUserId}&isAcceptAcknowledgment=${isAcceptAcknowledgment} `);
  }
  AddUserKycAnswers(investorUserId:string,body: SubmitKYCAnswersInputDto): Observable<any> {

    return this.baseApi.Post(`${this.controllerUrl}AddUserKycAnswers?investorUserId=${investorUserId}`, body);
  }
  GetRelatedQuestion(questionId: string): Observable<Question> {

    return this.baseApi.Get(`${this.controllerUrl}GetRelatedQuestion?questionId=${questionId}`);
  }
  AnswerFatcaQuestions(investorUserId:string,body: SubmitKYCAnswersInputDto): Observable<any> {

    return this.baseApi.Post(`${this.controllerUrl}AnswerFatcaQuestions?investorUserId=${investorUserId}`, body);
  }
  GetFatcaQuestions(): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetFatcaQuestions `);
  }
  UserKycRejectReason(investorUserId:string): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}UserKycRejectReason?investorUserId=${investorUserId} `);
  }
  UploadDocKyc(body: UploadKycInputDto): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}UploadDocKyc`, body);
  }
}